import { render, staticRenderFns } from "./traMediciReturn.vue?vue&type=template&id=bc6fe672&scoped=true"
import script from "./traMediciReturn.vue?vue&type=script&lang=js"
export * from "./traMediciReturn.vue?vue&type=script&lang=js"
import style0 from "./traMediciReturn.vue?vue&type=style&index=0&id=bc6fe672&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc6fe672",
  null
  
)

export default component.exports